import React from "react";
import BaseCarousel from "./BaseCarousel";
import LeftArrow from "../../assets/icons/pagination-left-arrow.svg";
import RightArrow from "../../assets/icons/pagination-right-arrow.svg";
import { MaskType } from "../MaskShapeContainer/MaskShapeContainer";

interface ICarousel {
  slides: JSX.Element[];
  slideSelectorColor: string;
  selectedSlideSelectorColor?: string;
  arrowButtonColor: string;
  customArrowSize?: string;
  height: string;
  width?: string;
  showSlideButtons?: boolean;
  showSelectorButtons?: boolean;
  selectorButtonsBottomPosition?: string;
  mask?: React.SVGAttributes<SVGElement>;
  maskClipPathId?: string;
  maskType?: MaskType;
}

const Carousel = ({
  slides,
  selectedSlideSelectorColor,
  slideSelectorColor,
  arrowButtonColor,
  customArrowSize,
  height,
  width,
  showSlideButtons = true,
  showSelectorButtons = true,
  selectorButtonsBottomPosition,
  mask,
  maskClipPathId,
  maskType,
}: ICarousel) => {
  const styleClasses = `${arrowButtonColor && arrowButtonColor.startsWith('[&>path]') ? arrowButtonColor : `[&>path]:${arrowButtonColor}`} ${
    customArrowSize ?? "w-[3.75rem] h-[7.5rem]"
  }`;

  return (
    <BaseCarousel
      slides={slides}
      slideSelectorColor={slideSelectorColor}
      selectedSlideSelectorColor={
        selectedSlideSelectorColor ?? slideSelectorColor
      }
      leftSlideButton={<LeftArrow className={styleClasses} />}
      rightSlideButton={<RightArrow className={styleClasses} />}
      showSlideButtons={showSlideButtons}
      showSelectorButtons={showSelectorButtons}
      height={height}
      width={width ?? "w-full"}
      selectorButtonsBottomPosition={selectorButtonsBottomPosition}
      mask={mask}
      maskClipPathId={maskClipPathId}
      maskType={maskType}
    />
  );
};

export default Carousel;
